module.exports = __webpack_public_path__ + "assets/images/glucose_r.a46bb346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/glucose_r.png
// module id = 721
// module chunks = 1